import { createKeys, featureKeys } from "Utilities/ReactQuery/fnKeys";

const PROFILE_2 = "profile2";
const HOUSEHOLD_RELATIONSHIPS = "householdRelationships";

export const userProfileKeys = createKeys(
  featureKeys.USER_PROFILE_FEATURE_KEY,
  {
    user: (userID) => [PROFILE_2, userID],
    householdRelationships: (userID) => [HOUSEHOLD_RELATIONSHIPS, userID],
  }
);
